import { Component, Inject, ViewChild } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import { service } from 'powerbi-client';

type EventHandler = (event?: service.ICustomEvent<unknown>) => void;

@Component({
  selector: 'app-nedap-dashboard',
  templateUrl: './nedap-dashboard.component.html',
  imports: [PowerbiReportComponent],
})
export class NedapDashboardComponent {
  @ViewChild(PowerbiReportComponent) reportObj!: PowerbiReportComponent;

  public readonly workspaceId: string;
  public readonly reportId: string;
  public readonly eventHandlersMap: Map<string, EventHandler> = new Map([
    [
      'loaded',
      () => {
        const report = this.reportObj.powerBiReport.getReport();
        report.setComponentTitle(
          this.localeService.translate('settings.third-parties.nedap-dashboard-title'),
        );
      },
    ],
    [
      'error',
      (event?: service.ICustomEvent<unknown>) => {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
  ]);

  constructor(
    @Inject(EnvironmentInjector)
    private readonly env: { NEDAP_WORKSPACE_ID: string; NEDAP_REPORT_ID: string },
    private readonly localeService: LocaleService,
  ) {
    this.workspaceId = this.env.NEDAP_WORKSPACE_ID;
    this.reportId = this.env.NEDAP_REPORT_ID;
  }
}
